import { velascaApi } from '@velasca/constants'
import { isWoman } from './globals'

type ApiUrl =
  | 'https://api.velasca.com'
  | 'https://api.velascawomen.com'
  | 'https://sg.api.velascawomen.com'
  | 'https://sg.api.velasca.com'

export const getVelascaApiUrl = (environment: string | undefined): ApiUrl => {
  if (environment === 'production') {
    return isWoman ? velascaApi.production.WOMAN : velascaApi.production.MAN
  }

  return isWoman ? velascaApi.staging.WOMAN : velascaApi.staging.MAN
}
